import React, { useEffect, useRef, useState } from "react";
import { Drawer, Modal } from "antd";
// import { fabric } from "fabric";
import fabric from "../../fabric";
import { useSelector, useDispatch } from "react-redux";
import {
  applyTemplate,
  setTemplates,
  setTemplatesDrawer,
} from "../../slices/creatorSlice";
// import sampleTemplate from "../../Templates/templates.json";
const TemplatesDrawer = (props) => {
  const visible = useSelector((state) => state.creator.templatesDrawerOpen);
  const templateCanvasRef = useRef(null);
  const dispatch = useDispatch();
  const [templateCanvas, setTemplateCanvas] = useState(null);
  const _templates = useSelector((state) => state.creator.templates);
  const _CanvasSize = useSelector((state) => state.creator.canvasSize);
  const [imgLinks, setImgLinks] = useState([]);
  const [templateModal, setTemplateModal] = useState(false);
  const [jsonData, setJsonData] = useState("");
  const [templatesFile, setTemplateFile] = useState("");
  /* -------------------- initialization of canvas -----------*/
  const initCanvas = () => {
    return new fabric.Canvas(templateCanvasRef.current, {
      height: _CanvasSize.width,
      width: _CanvasSize.height,
      backgroundColor: "#ffffff",
    });
  };
  function importAll(r) {
    return r.keys().map(r);
  }
  useEffect(() => {
    const templates = importAll(
      require.context("../../Templates/", false, /\.(json)$/)
    );
    console.log(templates);
    setTemplateFile(templates);
    setTemplateCanvas(initCanvas());
    dispatch(setTemplates(true));
  }, []);
  /* -------------------------------------------------------------*/

  /*-------------------- Creating image of template for thumbnail -----------*/
  const setDataURL = async (template) => {
    const dataURL = await templateCanvas.toDataURL({
      width: _CanvasSize.width,
      height: _CanvasSize.height,
      left: 0,
      top: 0,
      format: "png",
    });
    console.log(dataURL);
    setImgLinks((data) => [...data, { imageSrc: dataURL, data: template }]);
    return null;
  };

  useEffect(() => {
    if (templateCanvas) {
      templatesFile.map((sampleTemplate) => {
        sampleTemplate.map(async (template) => {
          templateCanvas.clear();
          var json = await JSON.stringify(template[0]); //first page of tamplate will show as thumbnail in templates drawer
          await templateCanvas.loadFromJSON(json, async () => {
            await setDataURL(template);
          });
          templateCanvas.renderAll();
          return null;
        });
        return null;
      });
    }
  }, [_templates]);
  /* ------------------------------------------------------------------------*/

  /* ----------------- Set selected template to main canvas when user clicked ----- */
  const setTemplate = (data) => {
    dispatch(applyTemplate(data.data));
    dispatch(setTemplatesDrawer(!visible));
    props.canvas.renderAll();
  };
  /* -----------------------------------------------------------------------------*/
  return (
    <Drawer
      title="Templates"
      placement={"left"}
      closable={true}
      onClose={() => {
        dispatch(setTemplatesDrawer(!visible));
      }}
      visible={!visible}
      key={"left"}
    >
      <div className="grid grid-cols-1 items-stretch gap-2">
        {imgLinks.map((data, i) => {
          return (
            <div key={i}>
              <img
                src={data.imageSrc}
                alt="template_preview"
                className="bg-cover cursor-pointer w-[300px] h-[300px] rounded"
                style={{ border: "1px solid black" }}
                onClick={(e) => {
                  e.preventDefault();
                  setTemplateModal(true);
                  setJsonData(data);
                }}
              />
            </div>
          );
        })}
        <Modal
          title="Warning"
          visible={templateModal}
          onOk={(e) => {
            e.preventDefault();
            setTemplate(jsonData);
            setTemplateModal(false);
          }}
          onCancel={(e) => {
            e.preventDefault();
            setTemplateModal(false);
          }}
          okText="Apply Template"
        >
          Your current progress will be overwritten, would you like to continue?
        </Modal>
        <div className="cursor-pointer hidden">
          <canvas
            ref={templateCanvasRef}
            style={{
              boxShadow: "0px 5px 15px 0px #0000001a",
            }}
          ></canvas>
        </div>
      </div>
    </Drawer>
  );
};

export default TemplatesDrawer;
